// Code from stackoverflow
export default {
    updateParameter(url, param, paramVal) {
        let TheAnchor = null,
            newAdditionalURL = '',
            tempArray = url.split('?'),
            baseURL = tempArray[0],
            additionalURL = tempArray[1],
            temp = '';

        if (additionalURL) {
            let tmpAnchor = additionalURL.split('#'),
                TheParams = tmpAnchor[0];

            TheAnchor = tmpAnchor[1];

            if (TheAnchor) {
                additionalURL = TheParams;
            }

            tempArray = additionalURL.split('&');

            for (let i = 0; i < tempArray.length; i++) {
                if (tempArray[i].split('=')[0] !== param) {
                    newAdditionalURL += temp + tempArray[i];
                    temp = '&';
                }
            }
        }
        else {
            let tmpAnchor = baseURL.split('#'),
                TheParams = tmpAnchor[0];

            TheAnchor  = tmpAnchor[1];

            if (TheParams) {
                baseURL = TheParams;
            }
        }

        if (TheAnchor) {
            paramVal += '#' + TheAnchor;
        }

        let newParameter = `${temp + param}=${paramVal}`;
        
        let urlUpdated = `${baseURL}?${newAdditionalURL + newParameter}`;
        
        if (!paramVal) {
            urlUpdated = urlUpdated.replace(new RegExp(`(\\?|&)${param}=(undefined|null)`), '');
        }
        
        return urlUpdated;
    },

    getParameterByName(url, name) {
        url = decodeURI(url);
        name = name.replace(/[[\]]/g, '\\$&');

        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);

        if (!results) {
            return null;
        }

        if (!results[2]) {
            return '';
        }

        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
};
